import React from "react";
import cn from 'classnames';
import Link from 'next/link';

const NavbarItemLink = ({ title, href, theme, onMouseEnter }) => {
  const onMouse = () => {
    onMouseEnter()
  }
  return (
    <li className="relative" onMouseEnter={onMouse} onFocus={onMouse} style={{ zIndex: 60 }}>
      <Link
        href={href}
        className={cn(theme.logo, 'bg-transparent text-sm flex justify-center px-4 border-0 relative z-10 hover:text-opacity-70')}>

        {title}

      </Link>
    </li>
  );
}

export default NavbarItemLink;